import { createContext, useContext } from "react";
import type { Kernel } from "@/kernel/Kernel";
import { PyodideKernel } from "@/kernel/PyodideKernel";

/** Фабрика ядра: в приложении — Pyodide, в тестах — FakeKernel. */
export const KernelFactory = createContext<() => Kernel>(() => new PyodideKernel());
export const useKernelFactory = () => useContext(KernelFactory);
